import { queryKeys } from '@/lib/query-keys';
import { authClient } from '@/lib/api/ts-rest';
import { useQuery } from '@tanstack/react-query';

export const useValidateResetToken = (token: string | null) => {
  return useQuery({
    queryKey: queryKeys.auth.validateResetToken(token),
    queryFn: () => {
      if (!token) return false;
      return authClient
        .validateResetToken({ body: { token } })
        .then((res) => (res.status === 201 ? res.body.valid : false))
        .catch(() => false);
    },
    enabled: !!token,
  });
};
